/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Studentform_Name_HintInputs */

const en_studentform_name_hint = /** @type {(inputs: Studentform_Name_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(start typing to pull from contacts)`)
};

const he_studentform_name_hint = /** @type {(inputs: Studentform_Name_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(התחל להקליד כדי למשוך מאנשי הקשר)`)
};

/**
* | output |
* | --- |
* | "(start typing to pull from contacts)" |
*
* @param {Studentform_Name_HintInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const studentform_name_hint = /** @type {((inputs?: Studentform_Name_HintInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Studentform_Name_HintInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_studentform_name_hint(inputs)
	return he_studentform_name_hint(inputs)
});